module.exports = __webpack_public_path__ + "img/close-up.6b95bf81.png";